{
  "nodes": [
    {
      "id": 0,
      "name": "854231",
      "shortname": "Electronic Integrated Circuits"
    },
    {
      "id": 1,
      "name": "854221",
      "shortname": "Monolithic integrated circuits, digital"
    },
    {
      "id": 2,
      "name": "854229",
      "shortname": "Electronic integrated circuits, monolithic"
    },
    { "id": 3, "name": "854260", "shortname": "Hybrid integrated circuits" },
    {
      "id": 4,
      "name": "854890",
      "shortname": "Electrical parts of machinery or apparatus, nes"
    },
    { "id": 5, "name": "854213", "shortname": "Metal oxide semiconductors" },
    {
      "id": 6,
      "name": "854214",
      "shortname": "Circuits obtained by bipolar technology"
    },
    {
      "id": 7,
      "name": "854219",
      "shortname": "Integrated circuits, monolitihic non-digital"
    },
    {
      "id": 8,
      "name": "854230",
      "shortname": "Other monolithic integrated circuits"
    },
    { "id": 9, "name": "854240", "shortname": "Hybrid integrated circuits" },
    {
      "id": 10,
      "name": "854890",
      "shortname": "Electrical parts of machinery or apparatus, nes"
    },
    {
      "id": 11,
      "name": "854211",
      "shortname": "Monolithic integrated circuits, digital"
    },
    {
      "id": 12,
      "name": "854219",
      "shortname": "Monolithic integrated circuits, except digital"
    },
    { "id": 13, "name": "854220", "shortname": "Hybrid integrated circuits" },
    {
      "id": 14,
      "name": "854800",
      "shortname": "Electrical parts of machinery and apparatus, nes"
    }
  ],
  "links": [
    { "source": 0, "target": 1, "weighted-value": 0.9, "un-value": 0 },
    { "source": 0, "target": 2, "weighted-value": 0.01, "un-value": 1 },
    { "source": 0, "target": 3, "weighted-value": 0.09, "un-value": 0 },
    { "source": 0, "target": 4, "weighted-value": 0, "un-value": 0 },
    { "source": 1, "target": 5, "weighted-value": 0.6, "un-value": 0 },
    { "source": 1, "target": 6, "weighted-value": 0.08, "un-value": 0 },
    { "source": 1, "target": 7, "weighted-value": 0.32, "un-value": 0 },
    { "source": 2, "target": 8, "weighted-value": 1, "un-value": 1 },
    { "source": 3, "target": 9, "weighted-value": 1, "un-value": 0 },
    { "source": 4, "target": 10, "weighted-value": 0, "un-value": 0 },
    { "source": 5, "target": 11, "weighted-value": 1, "un-value": 0 },
    { "source": 6, "target": 11, "weighted-value": 1, "un-value": 0 },
    { "source": 7, "target": 11, "weighted-value": 0.24, "un-value": 0 },
    { "source": 7, "target": 12, "weighted-value": 0.76, "un-value": 0 },
    { "source": 8, "target": 12, "weighted-value": 1, "un-value": 1 },
    { "source": 9, "target": 13, "weighted-value": 1, "un-value": 0 },
    { "source": 10, "target": 14, "weighted-value": 0, "un-value": 0 }
  ]
}
